import loader from '../images/Iphone-spinner-2.gif'

export const Loader = () => {
    return (
        <img src={loader} className='loaderimg'/>
    )
}